export const AnalyticsKey = {
  ADDIN: {
    OPEN: "addin.open",
    DOCUMENT: {
      HIGHLIGHT: "addin.document.highlight",
    },
  },
  USER: {
    RISK_ANALYSIS: {
      REFRESH: "user.riskAnalysis.refresh",
      LABEL_ACCORDION_RESULT: {
        OPEN: "user.riskAnalysis.labelAccordionResult.open",
        CLOSE: "user.riskAnalysis.labelAccordionResult.close",
        HIGHLIGHT_NAVIGATION: {
          NEXT: "user.riskAnalysis.labelAccordionResult.highlightNavigation.next",
          PREVIOUS: "user.riskAnalysis.labelAccordionResult.highlightNavigation.previous",
        },
        VIEW_FULL_REPORT: "user.riskAnalysis.labelAccordionResult.viewFullReport",
      },
    },
  },
  AUTH: {
    LOGIN: {
      SUCCESS: "auth.login.success",
      FAILURE: "auth.login.failure",
    },
    LOGOUT: "auth.logout",
  },
  WORD: {
    DOCUMENT: {
      OPEN: "wordAddin.document.open",
      HIGHLIGHT: "wordAddin.document.highlight",
    },
  },
  PLAYBOOK: {
    FETCH: {
      SUCCESS: "playbook.fetch.success",
      FAILURE: "playbook.fetch.failure",
    },
    CREATE: {
      SUCCESS: "playbook.create.success",
      FAILURE: "playbook.create.failure",
    },
    DUPLICATE: {
      SUCCESS: "playbook.duplicate.success",
      FAILURE: "playbook.duplicate.failure",
    },
    UPDATE: {
      SUCCESS: "playbook.update.success",
      FAILURE: "playbook.update.failure",
    },
    DELETE: {
      SUCCESS: "playbook.delete.success",
      FAILURE: "playbook.delete.failure",
    },
  },
  RISK_ANALYSIS: {
    LABEL_PROMPTS: "riskAnalysis.labelPrompts",
    START: "riskAnalysis.start",
    FINISH: "riskAnalysis.finish",
    LABELING: {
      START: "riskAnalysis.labeling.start",
      FINISH: "riskAnalysis.labeling.finish",
    },
    CLAUSE_ANALYSIS: {
      START: "riskAnalysis.clauseAnalysis.start",
      FINISH: "riskAnalysis.clauseAnalysis.finish",
    },
  },
  REDLINES: {
    APPLY: "redlines.apply",
    SHOW: "redlines.show",
  },
} as const;

// Create a type for all possible analytics keys
export type AnalyticsKeyType = typeof AnalyticsKey;
